const PLATFORMS = [
  { name: "Teams", asset: "microsoft-teams" },
  { name: "Gmail", asset: "gmail" },
  { name: "Slack", asset: "slack" },
  { name: "Zoom", asset: "zoom" },
  { name: "Webex", asset: "webex" },
  { name: "Discord", asset: "discord" },
  { name: "Outlook", asset: "microsoft-outlook" },
];

export const PlatformLogos = () => (
  <ul
    className="mt-7 flex flex-wrap items-start gap-x-4 gap-y-4 sm:gap-x-5"
    aria-label="Communication apps"
    data-testid="hero-platform-logos"
  >
    {PLATFORMS.map(({ name, asset }, index) => (
      <li key={asset} className="platform-logo flex w-11 flex-col items-center gap-2" data-testid={`platform-${asset}`}>
        <img
          src={`/logos/${asset}.svg`}
          alt={`${name} logo`}
          width="24"
          height="24"
          decoding="async"
          className="platform-logo-image h-6 w-6 object-contain"
          style={{ animationDelay: `${index * 0.06}s` }}
          data-testid={`platform-logo-${asset}`}
        />
        <span className="font-body text-xs text-mist" data-testid={`platform-name-${asset}`}>{name}</span>
      </li>
    ))}
  </ul>
);